<template>
  <div class="member-container">
    <div
      @mouseenter="
        setCursor($t('read-more'), () => {}, {
          'font-size': '14px',
          width: '100px',
          height: '100px',
          background: '#FFC800',
          'z-index': '1',
        })
      "
      @mouseleave="
        setCursor('', () => {}, {
          'font-size': '14px',
          background: '#FFC800',
          width: '25px',
          height: '25px',
          'z-index': '-1',
          position: 'absolute',
        })
      "
    >
      <div class="flex justify-center">
        <img
          :src="member.teamconfiguration?.memberImage?.sourceUrl"
          class="member-photo"
        />
      </div>
      <div class="text-l text-center whitespace-nowrap txt-q pt-8 pb-3">
        {{ member.title }}
      </div>
      <div class="text-t text-center pb-1">
        <b>{{ member?.teamconfiguration?.position }}</b>
      </div>
      <div class="text-t text-center pb-1">
        <b>{{ member?.teamconfiguration?.subPosition }}</b>
      </div>
    </div>
    <div
      @click.stop.prevent
      v-if="from === 'contact'"
      class="text-t text-center font-light pt-2"
    >
      <a
        class="font-light underline hover:no-underline"
        target="_blank"
        rel="noopener noreferrer"
        :href="`mailto:${member?.teamconfiguration?.email}`"
        @click.stop
        >{{ member?.teamconfiguration?.email }}</a
      >
    </div>
    <div
      @click.stop.prevent
      v-if="from === 'contact'"
      class="text-center font-light"
    >
      <a
        class="font-light underline hover:no-underline"
        :href="`tel:${member?.teamconfiguration?.phone}`"
        rel="noopener noreferrer"
        @click.stop
        >{{ member?.teamconfiguration?.phone }}</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "TeamMember",
  props: {
    member: {
      type: Object,
      required: true,
    },
    from: {
      type: String,
      default: "",
    },
    setCursor: {
      type: Function,
    },
  },
};
</script>

<style scoped lang="scss">
.member-container {
  .member-photo {
    width: 180px;
    height: 180px;
    border-radius: 999px;
    object-fit: cover;
    object-position: top;
  }
}
</style>
